import React from 'react';
import InstoreMerchantRebate from 'core/modules/InstoreMerchantRebate/InstoreMerchantRebate';
import { highlightMatch } from '../../utils/highlightMatch';

export function InstoreMatches({ instoreMatches, isPopUpView, getTitle }) {
  if (instoreMatches.length === 0) {
    return null;
  }

  // Pop up view: show a maximum of 1 in-store offer
  const instoreMatchesToShow = isPopUpView ? instoreMatches.slice(0, 1) : instoreMatches;

  return (
    <>
      <h3 className="mn_quickSearchInstoreMatchingTitle">In-store offers</h3>
      <div className="mn_instoreMatchesWrapper">
        {instoreMatchesToShow.map((match) => {
          const { merchant, matchText } = match;
          const {
            id, name, offers = [], href,
          } = merchant;
          const instoreOffer = offers[0];
          const highlighted = highlightMatch(name, matchText);

          return (
            <a
              href={href}
              key={`${name}-instore`}
              className="mn_quickSearchMatch mn_instoreMatch"
              data-merchant-name={name}
              data-merchant-id={id}
              data-merchant-type="instore"
              title={getTitle(name, true)}
            >
              <span className="mn_matchText" key={id}>{highlighted}</span>
              <span className="mn_dash">&nbsp;-&nbsp;</span>
              <InstoreMerchantRebate offer={instoreOffer} showInstoreRebatePrefix={false} />
            </a>
          );
        })}
      </div>
    </>
  );
}

export default InstoreMatches;
